import { Chip } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ExitToAppIcon from '@mui/icons-material/ExitToApp';
import MailOutlineIcon from '@mui/icons-material/MailOutline';
import RemoveCircleOutlineIcon from '@mui/icons-material/RemoveCircleOutline';
import type { UserStatus } from '../../../api/userManagementApi';

interface UserStatusBadgeProps {
  status: UserStatus;
}

const statusConfig: Record<
  UserStatus,
  {
    label: string;
    color: 'default' | 'success' | 'warning' | 'error';
    icon: React.ReactElement;
  }
> = {
  Active: {
    label: 'Active',
    color: 'success',
    icon: <CheckCircleIcon sx={{ fontSize: 16 }} />,
  },
  InvitationSent: {
    label: 'Invitation Sent',
    color: 'warning',
    icon: <MailOutlineIcon sx={{ fontSize: 16 }} />,
  },
  Inactive: {
    label: 'Offboarded',
    color: 'default',
    icon: <RemoveCircleOutlineIcon sx={{ fontSize: 16 }} />,
  },
  Offboarding: {
    label: 'Offboarding',
    color: 'error',
    icon: <ExitToAppIcon sx={{ fontSize: 16 }} />,
  },
};

export function UserStatusBadge({ status }: UserStatusBadgeProps) {
  const config = statusConfig[status] ?? {
    label: status || 'Unknown',
    color: 'default' as const,
    icon: <RemoveCircleOutlineIcon sx={{ fontSize: 16 }} />,
  };

  return (
    <Chip
      label={config.label}
      color={config.color}
      size="small"
      icon={config.icon}
      sx={{ fontWeight: 500 }}
    />
  );
}
